import PathwayCard from './component'
export default PathwayCard
